/*
  og-lazy (owner 2026-10-20, homepage speed): sections with the "Load when scrolled near" setting render only an empty
  placeholder in the page (snippets/og-lazy.liquid). When a placeholder comes within ~1.5 screens of the viewport this
  fetches the real section through Shopify's Section Rendering API (?sections=, up to 5 per request) and swaps it in.
  The section knows it is being fetched because section.index is blank in Section Rendering API responses.
  Scripts inside the fetched HTML are re-created so they run; external ones already on the page are not loaded twice.
*/
(function () {
  if (window.__ogLazy) return;
  window.__ogLazy = true;

  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'module' && type.indexOf('javascript') === -1) return; // JSON-LD, templates etc.
      var src = old.getAttribute('src');
      if (src) {
        var seen = Array.prototype.some.call(document.scripts, function (s) {
          return s !== old && s.getAttribute('src') === src && !root.contains(s);
        });
        if (seen) { old.remove(); return; }
      }
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      if (!src) s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  // Stylesheets the section links to are loaded into <head> first, so the section never shows unstyled and jumps.
  function css(fresh) {
    var waits = [];
    fresh.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (l) {
      var href = l.getAttribute('href');
      var have = Array.prototype.some.call(document.querySelectorAll('link[rel="stylesheet"]'), function (x) { return x.getAttribute('href') === href; });
      if (have) return;
      var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = href;
      waits.push(new Promise(function (res) { n.onload = n.onerror = res; setTimeout(res, 3000); }));
      document.head.appendChild(n);
    });
    return Promise.all(waits);
  }

  function swap(id, html) {
    var wrap = document.getElementById('shopify-section-' + id);
    if (!wrap || !html) return Promise.resolve(false);
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var fresh = tpl.content.getElementById('shopify-section-' + id);
    if (!fresh || fresh.querySelector('[data-og-lazy]')) return Promise.resolve(false); // never swap a placeholder for a placeholder
    return css(fresh).then(function () {
      wrap.replaceChildren.apply(wrap, Array.prototype.slice.call(fresh.childNodes));
      runScripts(wrap);
      wrap.dispatchEvent(new CustomEvent('og:lazy-loaded', { bubbles: true, detail: { id: id } }));
      return true;
    });
  }

  function fail(ids) {
    ids.forEach(function (id) {
      var ph = document.querySelector('[data-og-lazy="' + id + '"]');
      if (ph) ph.style.minHeight = '0'; // collapse instead of leaving a gap
    });
  }

  function load(ids, attempt) {
    var q = location.search.replace(/^\?/, '').split('&').filter(function (x) { return x && x.indexOf('sections=') !== 0 && x.indexOf('section_id=') !== 0; });
    var url = location.pathname + '?' + q.concat('sections=' + encodeURIComponent(ids.join(','))).join('&');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (map) {
        return Promise.all(ids.map(function (id) { return swap(id, map[id]); })).then(function (ok) {
          var missing = ids.filter(function (id, i) { return !ok[i]; });
          if (missing.length) fail(missing);
        });
      })
      .catch(function () { if (!attempt) setTimeout(function () { load(ids, 1); }, 1500); else fail(ids); });
  }

  function start() {
    var phs = document.querySelectorAll('[data-og-lazy]');
    if (!phs.length) return;
    if (!('IntersectionObserver' in window)) {
      var all = Array.prototype.map.call(phs, function (p) { return p.getAttribute('data-og-lazy'); });
      for (var i = 0; i < all.length; i += 5) load(all.slice(i, i + 5));
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var ids = [];
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        ids.push(e.target.getAttribute('data-og-lazy'));
      });
      for (var i = 0; i < ids.length; i += 5) load(ids.slice(i, i + 5));
    }, { rootMargin: '1500px 0px' });
    phs.forEach(function (p) { io.observe(p); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
